/*eslint-disable */
import {bus} from '@/main';
export default {
  name: 'interview-remark-popup',
  components: {},
  props: ['remarks'],
  data () {
    return {
      remarksData:''
    }
  },
  computed: {

  },
  mounted () {
    console.log(this.remarks)
    this.remarksData = this.remarks
  },
  methods: {
    blurbTextPopupClosed(){
      bus.$emit('remarkPopupShowStateeBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    }
  }
}